<template>
  <div :data-app-theme="$store.getters.theme" class="experience-container">
    <h2 class="section-title">PROFESSIONAL EXPERIENCE</h2>

    <div
      v-for="(job, index) in experiences"
      :key="index"
      class="experience-card"
    >
      <button type="button" class="experience-header" :aria-expanded="job.expanded" @click="toggleDetails(index)">
        <span class="experience-info">
          <img :src="job.logo" :alt="job.company + ' logo'" class="company-logo" />
          <span class="text-content">
            <strong class="job-title">{{ job.title }}</strong>
            <span class="company-name">{{ job.company }}</span>
          </span>
        </span>
      </button>

      <transition name="fade">
        <div v-if="job.expanded" class="job-details">
          <ul>
            <li v-for="(detail, i) in job.details" :key="i">{{ detail }}</li>
          </ul>
        </div>
      </transition>

      <button type="button" class="read-more" :aria-expanded="job.expanded" @click="toggleDetails(index)">
        {{ job.expanded ? "Show Less" : "Read More" }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      experiences: [
        {
          title: "SOFTWARE ENGINEER",
          company: "OUTLIER",
          logo: require("@/assets/Company/outlier.jpg"), // Correct Vue import
          details: [
            "Train machine learning models to optimize code quality, debugging, and performance analysis for JavaScript, Python, and frameworks.",
            "Collaborate with teams to design AI-driven tools that assist developers in automating repetitive coding tasks and improving development efficiency.",
            "Leverage large-scale codebases and datasets to train AI models for predictive coding, error detection, and code completion, ensuring high accuracy and reliability.",
          ],
          expanded: false,
        },
        {
          title: "SOFTWARE ENGINEER & TECH CONSULTANT",
          company: "LUMINATION LABS",
          logo: require("@/assets/Company/labs.jpg"), // Correct Vue import
          details: [
            "Provided expert consulting services while conducting thorough needs assessments and gap analyses to identify clients’ technological challenges and opportunities.",
            "Implemented full-stack features for projects utilizing modern stacks, ensuring integration and optimal performance of customer-facing applications.",
            "Established and managed fully automated CI/CD pipelines leveraging cloud technologies, resulting in deployment efficiency and reliability.",
            "Built RESTful APIs and microservices, enabling efficient communication between frontend and backend systems, improving overall system responsiveness.",
          ],
          expanded: false,
        },
        {
          title: "TECHNICAL PROJECT MANAGER",
          company: "FROMAGGIO",
          logo: require("@/assets/Company/fromaggio.png"), // Correct Vue import
          details: [
            "Spearheaded the company's website redesign as a Developer, enhancing functionality and optimizing performance, leading to a 15% surge in online pre-sales.",
            "Transitioned to Project Manager, planning and execution of the hero product’s mobile app, reducing costs by 20% and expediting delivery times.",
            "Orchestrated global cross-functional teams, enhancing communication flow and achieving a 25% improvement in project delivery efficiency.",
            "Successfully met crucial deadlines, mitigating potential delays and ensuring the timely launch of the hero product app.",
          ],
          expanded: false,
        },
        {
          title: "TECHNICAL SUPPORT ENGINEER",
          company: "WIX.COM",
          logo: require("@/assets/Company/wix.png"), // Correct Vue import
          details: [
            "Resolved complex technical issues, collaborating with users to identify root causes and implement effective solutions, achieving a high first-contact resolution rate.",
            "Identified and promptly escalated critical bugs and technical issues to the development team, ensuring timely resolution and follow-up, reducing average resolution time.",
            "Collected and analyzed user feedback and usage data, identifying customer trends, pain points, and feature requests, contributing to product updates that enhanced user experience.",
            "Conducted comprehensive reviews of user sites, pinpointing areas for improvement, enhancing overall code quality, while providing guidance on Wix APIs and developer tools.",
          ],
          expanded: false,
        },
        {
          title: "WEB DEVELOPER",
          company: "ZIMALA",
          logo: require("@/assets/Company/zimala.jpg"), // Correct Vue import
          details: [
            "Designed, developed, and managed WordPress websites for a diverse clientele, spanning small businesses to Fortune 500 companies.",
            "Collaborated with the Creative Director to implement content production and online marketing strategies, leading to a 15% boost in organic traffic and user interactions.",
            "Streamlined client communication channels, ensuring effective engagement, and resulting in an increased improvement in client satisfaction rates.",
          ],
          expanded: false,
        },
      ],
    };
  },
  methods: {
    toggleDetails(index) {
      this.experiences[index].expanded = !this.experiences[index].expanded;
    },
  },
};
</script>

<style scoped>
/* Container */
.experience-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* Section Title */
.section-title {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

/* Experience Card */
.experience-card {
  background: #ececed;
  border-radius: 12px;
  padding: 20px;
  transition: all 1s ease-in-out;
  /* box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.1); */
}

/* Experience Header */
.experience-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

/* Experience Info */
.experience-info {
  display: flex;
  justify-content: flex-start;
  gap: 14px;
  align-items: center;
  width: 100%;
}

/* Job Title and Company Name */
.text-content {
  flex-grow: 1;
  min-width: 0;
}

.job-title {
  font-size: 18px;
  font-weight: bold;
}

.company-name {
  font-size: 14px;
  color: #555;
}

/* Company Logo */
.company-logo {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 8px;
  object-fit: contain;
}

/* Job Details */
.job-details {
  margin-top: 10px;
  padding-left: 10px;
}

.job-details ul {
  list-style: disc;
  padding-left: 20px;
  margin-top: 5px;
}

/* Read More Button */
.read-more {
  text-align: left;
  font-size: 14px;
  color: #black;
  /* font-weight: bold; */
  cursor: pointer;
  margin-top: 10px;
  transition: color 0.3s;
}

/* .read-more:hover {
  color: #0056b3;
} */

/* Smooth Transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Dark Mode */
[data-app-theme="dark"] .section-title, .section-title[data-app-theme="dark"] {
    color: #ececed;
  }
[data-app-theme="dark"] .read-more, .read-more[data-app-theme="dark"] {
    color: #ececed;
  }
[data-app-theme="dark"] .experience-card, .experience-card[data-app-theme="dark"] {
    background: #333;
    color: white;
  }
[data-app-theme="dark"] .company-name, .company-name[data-app-theme="dark"] {
    color: #ccc;
  }
</style>
